import { render, staticRenderFns } from "./ServerManagement.vue?vue&type=template&id=0120739c&scoped=true&"
import script from "./ServerManagement.vue?vue&type=script&lang=js&"
export * from "./ServerManagement.vue?vue&type=script&lang=js&"
import style0 from "./ServerManagement.vue?vue&type=style&index=0&id=0120739c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0120739c",
  null
  
)

export default component.exports